module.exports = __webpack_public_path__ + "img/icon-approval.74f1eb0c.svg";